import { root_props } from '../main';

export function getUserName() {
    return root_props.user.name
}
